import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import style from './style.css';
import DestinationsMenu from './destinations_menu';
import TopLinks from './top_links';
import { doGetMenu } from '../../store/reducers';


class LargeHeader extends Component {

    constructor(props){
        super(props)
        this.state = {show_menu: null}
        this._show_menu = this._show_menu.bind(this);
        this._hide_menu = this._hide_menu.bind(this);
        this.hovering = {
            onMouseOver: () => this._show_menu('destinations') , 
            onMouseOut: () => this._hide_menu()
        }
    }

    componentWillMount() {
        this.props._doGetMenu();
    }

    _show_menu(menu){
        clearTimeout(this.hideMenuTimer)
        this.setState({...this.state, show_menu: ( menu )})
    }
    _hide_menu(){
        this.hideMenuTimer = setTimeout(()=> {
            this.setState({...this.state, show_menu: null })
        } ,100)
    }
    render() {
        const menu = this.props.home_menu;
        return (
            <header className={ style.header }>
                <TopLinks />
                <div className={ `${style.innerHeader} ${style.btline}`}>
                    <div className={ `${style.nav} container no-padding` }>
                        <a className={style.logo} style={{backgroundImage: `url('https://www.sunrise-resorts.com/images/logos/sunrise_logo.svg')`}}>&nbsp;</a>
                        <nav>
                            <ul className={ style.menuBar }>
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li className={ this.state.show_menu==='destinations' ? style.activeMenu : `` }>
                                    <Link to="/" {...this.hovering} >Destinations</Link>
                                </li>
                                <li>
                                    <Link to="/">Experiences</Link>
                                </li>
                                <li>
                                    <Link to="/">Grand Edition</Link>
                                </li>
                                <li>
                                    <Link to="/">Offers</Link>
                                </li>
                                <li>
                                    <Link to="/">Gallery</Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                                    {this.state.show_menu === 'destinations' &&
                                    <div className={style.dropmenu}  {...this.hovering} >
                                        { menu && menu.destinations && <DestinationsMenu destinations={menu.destinations} /> }
                                    </div>
                                    }
                </div>
            </header>
        );
    }
}

export default connect( 
    state =>({
        home_menu: state.app.home_menu, 
        browser: state.browser,
    }),
    dispatch => { 
        return { 
            _doGetMenu: () => { dispatch(doGetMenu()) } ,
        } 
    }
)(LargeHeader);



// WEBPACK FOOTER //
// ./src/components/largeheader/index.js